module.exports = {"131125100":"安平镇","131125101":"马店镇","131125102":"南王庄镇","131125103":"大子文镇","131125104":"东黄城镇","131125200":"大何庄乡","131125201":"程油子乡","131125202":"西两洼乡","131125400":"河北丝网工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131125.json
// module id = 249
// module chunks = 0